define((require) => {
    "use strict";

    var ImprovedView     = require("editor/zbone/ImprovedView"),
        Permissions      = require("shared/security/Permissions"),
        {isBlank}        = require("shared/util/StringUtils"),
        SystemMessages   = require("editor/services/SystemMessages"),
        template         = require("editor/ui/settings/fonts/ManageTypekitIntegrationView.tpl"),
        ValidateBehavior = require("ui/behaviors/ValidateBehavior");

    return ImprovedView.extend("ManageTypekitIntegrationView", {

        className: "tab-pane",

        template: template,

        templateHelpers: function() {
            return {
                permissionToManage: Permissions.Privileges.ADMIN.can()
            };
        },

        bindings: {
            ".typekit-api-token-input": {
                observe: "typekitApiToken"
            }
        },

        behaviors: {
            validateBehavior: {
                behaviorClass: ValidateBehavior,
                inputValidation: {
                    ".typekit-api-token-input": {
                        validateAfter: "beforeSubmit",
                        // Mark as bound to model, so make sure we cancel pending save requests on error!
                        model: true,
                        validator: function(key) {
                            // 40 word characters (upper/lowercase letters + digits).
                            return isBlank(key) || /^\w{40,40}$/.test(key);
                        },
                        validatorAsync: {
                            "typekit:valid:token": {
                                source: SystemMessages,
                                validator: function(valid) {
                                    return valid;
                                }
                            }
                        },
                        errorText: function(value, type) {
                            return type === "async" ? "The Typekit token appears to be invalid" : "Not a valid Typekit API Token";
                        }
                    }
                }
            }
        },

        active: function(state) {
            this.$el.toggleClass("active", state);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/fonts/ManageTypekitIntegrationView.js